import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.custom-placeholder {
  & .p-placeholder > span, & .p-placeholder > span div, & span.p-select-label, & div.p-multiselect-label {
  	color: ${dt('customPlaceholder.color')};
  	font-weight: ${dt('customPlaceholder.fontWeight')};
@media screen and (min-width: 768px) and (max-width: 1439px) {
    font-size: ${dt('form.field.sm.font.size')} !important;
    line-height: ${dt('form.field.sm.font.lineHeight')} !important;
  }

@media screen and (min-width: 1440px) and (max-width: 1919px) {
    font-size: ${dt('form.field.md.font.size')} !important;
    line-height: ${dt('form.field.md.font.lineHeight')} !important;
  }

@media screen and (min-width: 1920px) {
    font-size: ${dt('form.field.lg.font.size')} !important;
    line-height: ${dt('form.field.lg.font.lineHeight')} !important;
  }
}
  }

.custom-placeholder.p-disabled {
  background-color: transparent !important;
  border-color: transparent !important;
}

.custom-placeholder.p-disabled span.p-select-label,
.custom-placeholder.p-disabled div.p-multiselect-label {
  color: ${dt('text.muted.color')} !important;
  font-weight: ${dt('customPlaceholder.fontWeight')} !important;
}

.custom-placeholder.p-disabled .p-select-dropdown,
.custom-placeholder.p-disabled .p-multiselect-dropdown {
  display: none !important;
}

`;
